import { render } from "./menuManagement.vue?vue&type=template&id=8d36a20a&scoped=true"
import script from "./menuManagement.vue?vue&type=script&lang=js"
export * from "./menuManagement.vue?vue&type=script&lang=js"

import "./menuManagement.vue?vue&type=style&index=0&id=8d36a20a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d36a20a"]])

export default __exports__